"use client";

import useSWR from "swr";
import {
  ImageAPI,
  ImageLockedCountByUserRequest,
} from "@/restapi/image";

const useImageLockedCountByUser = (
  request: ImageLockedCountByUserRequest | null
) => {
  const shouldFetch = !!request?.userUuid;

  const { data, error, isLoading, mutate } = useSWR(
    shouldFetch ? `image-locked-count-by-user-${request.userUuid}` : null,
    () => ImageAPI.lockedCountByUser(request as ImageLockedCountByUserRequest),
    {
      refreshInterval: 5000,
      revalidateOnFocus: false,
    }
  );

  return {
    lockedCount: data?.lockedCount ?? 0,
    hasLockedImages: data?.hasLockedImages ?? false,
    data,
    isLoading,
    isError: !!error,
    refetch: mutate,
  };
};

export { useImageLockedCountByUser };